import { ButtonLink } from 'braid-design-system';

import { createDotNetLinkUrl } from 'src/utils';

const FindOutMore = () => (
  <ButtonLink
    href={createDotNetLinkUrl('/business-resources/franchise-advertising')}
    variant="solid"
    tone="neutral"
  >
    Find out more
  </ButtonLink>
);

export default FindOutMore;
